'use strict';exports.__esModule = true;var _analyticsManager = require('./analytics/analyticsManager');
var _analyticsConstants = require('./analytics/analyticsConstants');





var addTrackedNote = function addTrackedNote(_ref)








{var id = _ref.id,note = _ref.note,token = _ref.token,_ref$category = _ref.category,category = _ref$category === undefined ? _analyticsConstants.eventCategory.notes : _ref$category,_ref$action = _ref.action,action = _ref$action === undefined ? _analyticsConstants.eventAction.add : _ref$action,_ref$label = _ref.label,label = _ref$label === undefined ? _analyticsConstants.eventLabel.homePage : _ref$label,_ref$track = _ref.track,track = _ref$track === undefined ? true : _ref$track,addPropertyNote = _ref.addPropertyNote;
  if (track) {
    (0, _analyticsManager.trackEvent)(category, action, label);
  }

  addPropertyNote({ noteData: { id: id, note: note }, token: token });
};exports.default =

addTrackedNote;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/addTrackedNote.js
// module id = 402
// module chunks = 0